module.exports = __webpack_public_path__ + "img/UTSNOW.c260d5b9.png";